import { useMemo } from 'react';
import {
  browserCookieIdExperiments,
  userIdExperiments
} from '~/constants/experiments';
import type { Experiments } from '~/contracts';
import BrowserCookies from '~/utilities/BrowserCookies';
import getUserId from '~/utilities/getUserId';

// e.g. { "srch-experiment": { identifier: "1234-abcd-5678-efgh" } }
const addIdentifierToExperimentsAndFilter = (
  experiments: Partial<Experiments>,
  identifier?: string
): Partial<Experiments> =>
  identifier
    ? Object.keys(experiments).reduce((acc, experimentName) => {
        acc[experimentName] = { identifier };

        return acc;
      }, {} as Partial<Experiments>)
    : {};

function useExperimentsWithIdentifiers() {
  const bcid = BrowserCookies.get('BrowserCookieId');
  const userId = getUserId();

  return useMemo(
    () => ({
      ...addIdentifierToExperimentsAndFilter(browserCookieIdExperiments, bcid),
      ...addIdentifierToExperimentsAndFilter(userIdExperiments, userId)
    }),
    [bcid, userId]
  );
}

export default useExperimentsWithIdentifiers;
